<template>
  <div>
    <div class="instrument-details__wrapper">
      <OrdersSection />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { Feature } from '@/modules/common/components/Feature';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { OrdersSection } from './components/OrdersSection';

@Component({
  components: {
    Feature,
    OrdersSection
  }
})
export default class InstrumentDetails extends Vue {
  get FeatureFlags() {
    return FeatureFlags;
  }
}
</script>

<style lang="less" scoped>
.instrument-details__wrapper {
  padding: @size-spacing-x600 @size-spacing-x400 @size-spacing-x800
    @size-spacing-x400;
}

.instrument-position__heading {
  padding-bottom: @size-spacing-x300;
}

.instrument-label__empty {
  margin-bottom: 20px;
  display: flex;
  align-items: left;
  color: @text-secondary;
  border-top: 1px solid @divider-primary;
  padding-top: @size-spacing-x350;
}

@media @notebookUp {
  .instrument-details__wrapper {
    padding: @size-spacing-x600 @size-spacing-x800 @size-spacing-x800
      @size-spacing-x800;
  }
}
</style>
